export const BASE_API_URL = '/api/v1'

export const APP_ENV = import.meta.env.VITE_REACT_APP_ENV

// Monitoring related configs
export const DATADOG_APPLICATION_ID = import.meta.env
  .VITE_DATADOG_APPLICATION_ID
export const DATADOG_CLIENT_TOKEN = import.meta.env.VITE_DATADOG_CLIENT_TOKEN

// Google Analytics tag
export const GOOGLE_ANALYTICS_TAG_ID = import.meta.env
  .VITE_GOOGLE_ANALYTICS_TAG_ID

export const FEEDBACK_FORM_URL = 'https://go.gov.sg/pair-search-feedback'
export const PAIR_SEARCH_GUIDE_URL = 'https://go.gov.sg/pair-search-guide'
export const REPORT_VULNERABILITY_URL =
  'https://www.tech.gov.sg/report_vulnerability'
export const HACK_FOR_PUBLIC_GOOD_URL = 'https://hack.gov.sg'
